import { Injectable, EventEmitter } from '@angular/core';
@Injectable({
	providedIn: 'root'
})
export class BuscaService {
	buscaEmitter = new EventEmitter<boolean>();
	fecharBusca = new EventEmitter<boolean>();
	constructor() {}

	enviaBusca(event) {
		this.buscaEmitter.emit(event);
	}

	enviaFecharBusca(event) {
		this.fecharBusca.emit(event);
	}
}
